import React, { useEffect, useState } from "react";
import { Drawer } from "antd";
import PickerList, { PickerGroup, PickerOption, labelForValue } from "./PickerList";
import SheetHeaderClose from "./SheetHeaderClose";

export type { PickerGroup, PickerOption };

interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  placeholder: string;
  fieldIcon: React.ReactNode;
  rowIcon: React.ReactNode;
  groups: PickerGroup[];
  value: string;
  allowFreeText?: boolean;
  onSelect: (option: PickerOption) => void;
}

export default function OptionPickerSheet({
  open,
  onClose,
  title,
  placeholder,
  fieldIcon,
  rowIcon,
  groups,
  value,
  allowFreeText = false,
  onSelect,
}: Props) {
  const selectedLabel = labelForValue(groups, value);
  const [query, setQuery] = useState(selectedLabel);

  useEffect(() => {
    if (open) setQuery(selectedLabel);
  }, [open, selectedLabel]);

  const commitFreeText = () => {
    const text = query.trim();
    if (!allowFreeText || !text) return;
    onSelect({ value: text, label: text });
  };

  return (
    <Drawer
      open={open}
      onClose={onClose}
      placement="bottom"
      height="92%"
      title={title}
      closable={false}
      extra={<SheetHeaderClose onClose={onClose} />}
      rootClassName="v2-sheet v2-sheet--picker"
    >
      <div className="v2-picker__field">
        {fieldIcon}
        <input
          value={query}
          placeholder={placeholder}
          readOnly={!allowFreeText}
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={(event) => event.key === "Enter" && commitFreeText()}
        />
      </div>

      <div className="v2-picker__list">
        <PickerList groups={groups} rowIcon={rowIcon} value={value} query={query} onSelect={onSelect} />
      </div>
    </Drawer>
  );
}
